import { render } from "./ContentAssignment.vue?vue&type=template&id=9584bd78"
import script from "./ContentAssignment.vue?vue&type=script&lang=js"
export * from "./ContentAssignment.vue?vue&type=script&lang=js"

import "./ContentAssignment.vue?vue&type=style&index=0&id=9584bd78&lang=scss"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__